import { TgMailing } from "@/modules/telegram/interfaces"
import { MAX_PAGE_BYTES, PAGE_SIZE } from "./constants"
import { serializePage } from "./serializePage"

const encoder = new TextEncoder()
const estimateBytes = (bodyJson: string): number =>
  encoder.encode(bodyJson).length

const splitInHalf = <T>(items: T[]): [T[], T[]] => {
  const mid = Math.ceil(items.length / 2)
  return [items.slice(0, mid), items.slice(mid)]
}

/**
 * Страницы по PAGE_SIZE с упреждающим сплитом по оценке размера (MAX_PAGE_BYTES),
 * чтобы 413 не приходил в штатном режиме. pageIndex в оценке не влияет на размер
 * существенно — используем 0.
 */
export const buildPages = (
  recipients: TgMailing.CallApiBody[],
): TgMailing.CallApiBody[][] => {
  const result: TgMailing.CallApiBody[][] = []
  for (let i = 0; i < recipients.length; i += PAGE_SIZE) {
    const queue: TgMailing.CallApiBody[][] = [
      recipients.slice(i, i + PAGE_SIZE),
    ]
    while (queue.length > 0) {
      const chunk = queue.shift() as TgMailing.CallApiBody[]
      const oversized =
        chunk.length > 1 &&
        estimateBytes(serializePage(0, chunk).bodyJson) > MAX_PAGE_BYTES
      if (oversized) {
        const [a, b] = splitInHalf(chunk)
        queue.unshift(a, b)
      } else {
        result.push(chunk)
      }
    }
  }
  return result
}
